module.exports = __webpack_public_path__ + "static/021-d47e305393824edba1df4af3013ae615.png";